import React from 'react';

import { ExpertsBlockConfig } from '@components/pages/PageTemplates/interfaces';
import { Reporter } from '@utils/backend-api/subscribe';

import Carousel from './Carousel';
import ExpertsBlockFeaturedVideo from './FeaturedVideo';

interface ExpertsProps {
  carouselClass?: string;
  config?: ExpertsBlockConfig;
  reporters: Reporter[];
  title?: string;
}

const Experts = ({ carouselClass, config, reporters }: ExpertsProps) => {
  return (
    <div className="mt-64 overflow-hidden px-16 sm:mt-96">
      <h2 className="m-0 text-center font-suisse-works text-headline-xs text-black md:text-headline-sm">
        {config?.experts_headline || 'For The Experts by The Experts'}
      </h2>
      <Carousel className={carouselClass} config={config} reporters={reporters} />
      <div className="mt-64 block sm:hidden">
        <ExpertsBlockFeaturedVideo
          poster={config?.poster_image}
          src={config?.video_url}
          title={config?.video_title}
        />
      </div>
    </div>
  );
};

export default Experts;
